import useCollection from 'core/hooks/useCollection'

const useGlobalNotes = ({ supercaseId }) => {
  return useCollection('globalNotes', { supercaseId })
}

export default useGlobalNotes
